@if (this.container.items.length>0) {
  <div class="col">
    <dhs-editable-grid #gridInput [resource]="'kit_details'" [config]="{'items':this.container.items}"
    (listen_changes)="listen_changesinShowKitInfo($event)"> </dhs-editable-grid>
    <div class="row">
      <div class="col-12" style="text-align: center;">
        <br/>
        <button type="button" class="primary-btn" (click)="closePopUp()">
          Submit
          <i aria-hidden="true" class="fa fa-save ml-2"></i>
        </button>
      </div>
    </div>
  </div>
}